import { OrderDirection } from "_shared/_api/ordering/order-direction";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { FeeSchedulesOrderField } from "work/fee-schedules/_api/queries/contracts/ordering/fee-schedules-order-parameters";
import { z } from "zod";

export type FeeSchedulesOrderJSON = z.infer<typeof FeeSchedulesOrderSchema.FeeSchedulesOrderJSONZ>;
export type FeeSchedulesOrderParams = z.infer<typeof FeeSchedulesOrderSchema.FeeSchedulesOrderZ>;

export default class FeeSchedulesOrderSchema {
	public static readonly FeeSchedulesOrderJSONZ = z
		.object({
			orderBy: z.enum(FeeSchedulesOrderField).nullish(),
			orderDir: z.enum(OrderDirection).nullish(),
		})
		.optional();

	public static readonly FeeSchedulesOrderZ = z
		.object({
			orderBy: z.enum(FeeSchedulesOrderField).optional(),
			orderDir: z.enum(OrderDirection).optional(),
		})
		.optional();

	public static create(values: FeeSchedulesOrderParams): FeeSchedulesOrderParams {
		return parseOrThrow(FeeSchedulesOrderSchema.FeeSchedulesOrderZ, values, {
			logError: true,
			schemaName: "FeeSchedulesOrderSchema",
			operation: "create",
			payloadSample: values,
		});
	}

	public static deserialize(data: FeeSchedulesOrderJSON): FeeSchedulesOrderParams {
		const parsed = parseOrThrow(FeeSchedulesOrderSchema.FeeSchedulesOrderJSONZ, data, {
			logError: true,
			schemaName: "FeeSchedulesOrderSchema",
			operation: "deserialize",
			payloadSample: data,
		});
		return FeeSchedulesOrderSchema.codec.decode(parsed);
	}

	public static serialize(params: FeeSchedulesOrderParams): FeeSchedulesOrderJSON {
		const parsed = FeeSchedulesOrderSchema.create(params);
		return FeeSchedulesOrderSchema.codec.encode(parsed);
	}

	private static readonly codec = z.codec(
		FeeSchedulesOrderSchema.FeeSchedulesOrderJSONZ,
		FeeSchedulesOrderSchema.FeeSchedulesOrderZ,
		{
			decode: (json) =>
				json
					? {
							orderBy: json.orderBy ?? undefined,
							orderDir: json.orderDir ?? undefined,
					  }
					: undefined,
			encode: (params) =>
				params
					? {
							orderBy: params.orderBy ?? null,
							orderDir: params.orderDir ?? null,
					  }
					: undefined,
		}
	);
}
